<template>
  <ClientOnly>
    <div class="sticky">
      <Badges class="badges" />
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
  import Badges from '~/features/badge/Badges.vue';
</script>

<style lang="scss" scoped>
  .sticky {
    position: sticky;
    z-index: 20;
    bottom: 0;
  }

  .badges {
    position: absolute;
    bottom: 0;
  }
</style>
